import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportManagementEndpoint } from '../constants/transport-management-endpoint';
import { API_URL } from '../../../../../services/config';
import { TransportManagementSearchCriteria } from '../models/transport-management.model';
import { TransportManagementTile } from '../models';
import { Observable } from 'rxjs';
import { convertDateRangesToWallClockUTC } from '../../../../../common';

@Injectable({ providedIn: 'root' })
export class TransportManagementLoadService {
  private readonly url = `${API_URL}${TransportManagementEndpoint.Base}${TransportManagementEndpoint.Loads}`;
  constructor(private http: WrapperHttpService) {}

  getLoadList({ size, page, ...filter }: TransportManagementSearchCriteria): Observable<TransportManagementTile> {
    return this.http.withLoading().post<TransportManagementTile>(this.url, {
      size,
      page,
      filter: convertDateRangesToWallClockUTC(filter),
    });
  }
}
